import { array, InferType, object, string } from 'yup'

export const cohortSchemaValidation = object({
  name: string().required(),
  sections: array(),
  groups: array(),
}).required()

export type CohortSchemaValidationType = InferType<typeof cohortSchemaValidation>
